/*
 * Our Beam design class. Defines the client-side logic for our design codes
 * Includes: bracing, self weight, load combos, services cases etc.
 */

import { LoadCombination } from "../load-combinations/load-combination"

 // valid configurations
 // north american steel -> AISC (LRFD, ASD)
 // wood -> NDS (LRFD, ASD)
 // european steel -> Simple Design
 // custom shape -> Simple Design
export class BeamFlexureDesign {
    constructor() {
        //design and service combinations
        this.designType = "LRFD"; // LRFD, ASD, None
        this.loadCombination = null;
        this.serviceCases = null;
        this.loadCases = null;

        //service case optoins
        this.includeService = true;
        this.liveLoadLimit = 360;
        this.deadPlusLiveLoadLimit = 360;
        this.snowOrWindLoadLimit = 360;
        this.totalLoadLimit = 240;

        //self-weight
        this.includeSelfWeight = true;

        //bracing options
        this.bracingType = "continuous"; //continuous, equal, custom, unbraced
        this.customBraces = [];
        this.bracesAtInflectionPoints = false;
        this.inflectionBraces = [];
        // new 4/3/2023 - braces spacing and starting location logic was wrong
        this.bracingStartLocation = 0.0
        this.braceSpacing = 144.0

        // wood design
        this.useLambdaOrCd = false;
        // new 8/1/2024 - pass in cd or lambda. Previously always set to 1 on the server
        this.cds = {
            "EQ1": 0.9, "EQ2": 1.0, "EQ3": 1.25, "EQ4": 1.15, "EQ5": 1.15, "EQ6": 1.25, "EQ7": 1.15, 
            "EQ8": 1.15, "EQ9": 1.6, "EQ10": 1.6, "EQ11": 1.6, "EQ12": 1.6, "EQ13": 1.25, "EQ14": 1.15, 
            "EQ15": 1.15, "EQ16": 1.6, "EQ17": 1.6, "EQ18": 1.6, "EQ19": 1.6, "EQ20": 1.6, "EQ21": 1.6, "EQ22": 1.6}
        this.lambdas = {
            "EQ1": 0.6, "EQ2": 0.8, "EQ3": 0.8, "EQ4": 0.8, "EQ5": 0.8, "EQ6": 0.8, "EQ7": 0.8, "EQ8": 0.8, 
            "EQ9": 0.8, "EQ10": 0.8, "EQ11": 0.8, "EQ12": 0.8, "EQ13": 1.0, "EQ14": 1.0, "EQ15": 1.0, "EQ16": 1.0, 
            "EQ17": 1.0, "EQ18": 1.0, "EQ19": 1.0, "EQ20": 1.0, "EQ21": 1.0}
        // new 8/11/2024 - repetitive member factor for dimensioned lumber - increase capacity by 15%
        this.useRepetitiveMemberFactor = false
    }

    static load(json) {
        const o = Object.assign(new BeamFlexureDesign, json)
        o.loadCombination = Object.assign(new LoadCombination, json.loadCombination)
        o.serviceCases = Object.assign(new LoadCombination, json.serviceCases)
        o.loadCases = Object.assign(new LoadCombination, json.loadCases)
        return o
    }

    getBracingStartLocation() {
        return this.bracingStartLocation
    }

    getBraceSpacing() {
        return this.braceSpacing
    }

    lambdaOrCdValue(equationName) {
        switch(this.loadCombination.name) {
            case 'LRFD': return this.lambdas[equationName]
            case 'ASD' : return this.cds[equationName]
            default: return 1.0
        }
    }

    updateLambdaOrCd(equationName, value) {
        switch(this.loadCombination.name) {
            case 'LRFD': 
                this.lambdas[equationName] = value
                break
            case 'ASD': 
                this.cds[equationName] = value
                break
        }
    }
 }

